// Func = limiting Scope for this file
var lastScrollTop = 0;
const headerNav = document.querySelector('.header_menu-full, #primary-nav');
(function(){

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			// resizeWindow();
		});
		// resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			// HIDE BURGER MENU
			if (headerNav !== null) {
				headerNav.classList.remove('active');
				document.querySelectorAll('.js-headerNavToggle').forEach(btn => {
					btn.classList.remove('active');
				});
			}
		});

		if (
			window.location.hash !== '' &&
			window.location.hash.includes('#')
		) {
			setTimeout(function () {
				$('html,body').animate(
					{
						scrollTop:
							$(window.location.hash).offset().top - $('#header').height() - 50,
					},
					'slow',
				)
			}, 1000)
		}

		$('.read-more').on('click', function() {
			var $this = $(this).attr('href');
        	$($this).slideToggle();
			if ($(this).text() == $(this).attr('data-more'))
				$(this).text("Less")
			else
				$(this).text($(this).attr('data-more'));
			return false;
		});

		// RESTAURANT MENUS FILTER
		document.querySelectorAll('.restMenus_filter li').forEach((btn, i) => {
			btn.addEventListener('click', _ => {
				document.querySelectorAll('.restMenus_filter li').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				document.querySelectorAll('.restMenus_item').forEach(room => {
					room.classList.remove('active');
					if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
						room.classList.add('active');
					}
				});
			});

			if (i === 0) btn.click();
		});

		// ANIMATE SCROLL ANCHOR ON CLICK
		document.querySelectorAll('.js-anchorAnimate').forEach(btn => {
			const target = document.querySelector( btn.getAttribute('href') );
			btn.addEventListener('click', e => {
				e.preventDefault();
				if (target !== null) {
					$('html,body').stop().animate({ scrollTop: target.offsetTop }, 500);
				}
			});
		});

		// TOGGLE HEADER MENU
		document.querySelectorAll('.js-headerNavToggle').forEach(btn => {
			const currentTarget = document.querySelector( btn.getAttribute('href') );
			btn.addEventListener('click', e => {
				e.preventDefault();
				currentTarget.classList.toggle('active');
				btn.classList.toggle('active', currentTarget.classList.contains('active'));
			});
		});

		// CREATE HEADER MINI MENU
		const miniMenuHolder = document.querySelector('.js-header_menuMini');
		if (miniMenuHolder !== null) {
			document.querySelectorAll('.privary-navigation__item').forEach((item, i) => {
				if (i < 3) {
					const itemAnchor = item.querySelector('a').outerHTML;
					const newItemHTML = `<li>${itemAnchor}</li>`;
					miniMenuHolder.insertAdjacentHTML('beforeend', newItemHTML);
				}
			});
		}

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

	});

	window.onload = function() {

		// INNER PAGES TOP MARGIN
		const headerHeight = document.getElementById('header').offsetHeight;
		const pagetHolder = document.querySelector('#default #content, #myGallery, .sitemap #content, #attractions #content');
		if (pagetHolder !== null) {
			pagetHolder.style.marginTop = `${headerHeight}px`;
		}

		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/
		//scrollDownAction(20, 'scroll');

		if(!document.getElementById('header').classList.contains('fixed')){ 
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			});
		}

		
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}